import { render, staticRenderFns } from "./BackSurgery.vue?vue&type=template&id=2d1b55a6&scoped=true"
import script from "./BackSurgery.vue?vue&type=script&lang=js"
export * from "./BackSurgery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1b55a6",
  null
  
)

export default component.exports